<script>
import appConfig from "@/app.config";
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

let user = JSON.parse(localStorage.getItem("user"));
let token = user.token;

export default {
  page: {
    title: "Ticket ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      loading: true,
      item: [],
      airports: [],
    };
  },
  created() {
    this.getData();
    this.getAirports();
  },
  components: {
    VueHtml2pdf,
  },
  methods: {
    formatTime(dateTime) {
      const time = new Date(dateTime).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return time;
    },
    formatDate(dateTime) {
      const formattedDate = new Date(dateTime).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const daysOfWeek = [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
      ];
      const dayOfWeek = new Date(dateTime).getDay();

      const formattedDayOfWeek = daysOfWeek[dayOfWeek];

      return `${formattedDate} ${formattedDayOfWeek}`;
    },
    formatDateTime(dateTime) {
      const formattedDate = new Date(dateTime).toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return formattedDate;
    },
    getAirports() {
      const api_url = process.env.VUE_APP_BASEURL + "/airport";

      axios
        .get(api_url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.airports = response.data?.data;
          console.log("bilet airportss", this.airports);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      const id = this.$route.params.id;
      const api_url = process.env.VUE_APP_BASEURL + "/reservation/" + id;

      axios
        .get(api_url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.item = response.data?.data?.flyRoutes;
          console.log(this.item);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<template>
  <div>
    <b-button
      variant="outline-secondary"
      class="position-absolute"
      style="
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000000;
      "
      @click="generateReport"
    >
      <i class="fa fa-print"></i> PDF Oluştur
    </b-button>
    <vue-html2pdf
      ref="html2Pdf"
      :enable-download="false"
      :filename="`ticket-${item.id}`"
      :show-layout="true"
      :float-layout="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
    >
      <section slot="pdf-content">
        <div class="container ticket">
          <div v-for="(flight, index) in item" :key="index" class="row">
            <div class="row mt-5">
              <div class="col-6 mb-3">
                <p class="ticket__name">
                  Sayın, {{ flight.customer?.customer_name }}
                </p>
                <p class="ticket__thanks">Bizi tercih ettiğiniz teşekkürler.</p>
              </div>
              <div class="col-6 text-right">
                <img src="@/assets/images/logo-fluid.png" height="80" />
              </div>
              <div class="col-12 mb-3">
                <p class="ticket__section-title">
                  HAVAYOLU ADI: {{ flight.airline_name }}
                </p>
              </div>
              <div class="col-12">
                <div class="d-flex align-items-center justify-content-between">
                  <p class="ticket__info-text"></p>
                  <table class="ticket__info-table">
                    <tr>
                      <td>Rezervasyon Kodu:</td>
                      <td class="fw-bold">{{ flight.reservation_number }}</td>
                    </tr>
                    <tr>
                      <td>İşlem Tarihiniz:</td>
                      <td class="fw-bold">
                        {{ formatDateTime(flight.created_at) }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="col-12">
                <p class="ticket__section-title">Seyahat Planı</p>
              </div>
              <div class="col-12">
                <table class="ticket__main-table">
                  <thead>
                    <tr>
                      <th>Nereden Nereye</th>
                      <th>Havayolu</th>
                      <th>Kalkış</th>
                      <th>Varış</th>
                      <th>Kabin/Sınıf</th>
                      <th>Paket</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ flight.flight_from.region_name }} -
                        {{ flight.flight_to.region_name }}
                        <span>{{ flight.flight_number }}</span>
                      </td>
                      <td>
                        {{ flight.flight_from.iata_code }} -
                        {{ flight.flight_to.iata_code }}
                      </td>
                      <td>
                        {{ formatTime(flight.flight_from_date) }}
                        <span>{{ formatDate(flight.flight_from_date) }}</span>
                      </td>
                      <td>
                        {{ formatTime(flight.flight_to_date) }}
                        <span>{{ formatDate(flight.flight_to_date) }}</span>
                      </td>
                      <td>
                        {{ flight.flight_baggage }} kg/{{
                          flight.flight_ticket_class
                        }}
                      </td>
                      <td>{{ flight.packet }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th>
                        <span
                          >{{ flight.flight_from.iata_code }}:
                          {{ flight.flight_from.country_name_tr }} -
                          {{ flight.flight_from.region_name }} -
                          {{ flight.flight_from.name }}</span
                        >
                        <span
                          >{{ flight.flight_to.iata_code }}:
                          {{ flight.flight_to.country_name_tr }} -
                          {{ flight.flight_to.region_name }} -
                          {{ flight.flight_to.name }}</span
                        >
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="col-12">
                <table class="ticket__total-table">
                  <thead class="ticket__total-table-head">
                    <tr>
                      <th>Yolcular</th>
                      <th>Toplam Tahsil Edilen Tutar</th>
                    </tr>
                  </thead>
                  <tbody class="ticket__total-table-body">
                    <tr>
                      <td>
                        <table class="ticket__total-table-second">
                          <thead>
                            <tr>
                              <th>Yolcu Adı</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {{ flight.customer?.customer_name }}
                                <span>{{ flight.flight_number }}</span>
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        {{ flight.sell_price }}
                        {{ flight.sell_currency.symbol }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.ticket {
  font-family: "Roboto", sans-serif;
  &__name {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0;
    color: hsl(0, 0%, 40%);
  }
  &__thanks {
    font-size: 1.2rem;
    font-weight: 500;
    color: hsl(0, 0%, 0%);
  }
  &__section-title {
    font-size: 1.5rem;
    color: #000;
    font-weight: 700;
    margin-bottom: 0;
    border-bottom: 10px solid #d3e1e2;
    text-transform: uppercase;
  }
  &__info {
    &-text {
      font-size: 1.2rem;
      color: #000;
      font-weight: 500;
    }
    &-table {
      width: 30%;
      margin-top: 1rem;
      border: 1px solid #79b5d0;
      color: #000;
      tr {
        border-bottom: 1px dotted #79b5d0;
        &:last-child {
          border-bottom: none;
        }
      }
      td {
        width: 50%;
        padding: 0.5rem;
      }
    }
  }
  &__main-table {
    width: 100%;
    thead {
      color: hsl(0deg 0% 60%);
      font-weight: 700;
      font-size: 1.2rem;
      tr {
        border-bottom: 3px solid hsl(0deg 0% 60%);
        th {
          padding: 0.5rem;
        }
      }
    }
    tbody {
      color: #000;
      font-weight: 500;
      font-size: 1.2rem;
      tr {
        border-bottom: 1px solid hsl(0deg 0% 60%);
      }
      td {
        padding: 0.5rem;
        span {
          display: block;
          font-size: 0.8rem;
          color: hsl(0deg 0% 60%);
        }
      }
    }
    tfoot {
      color: #000;
      font-weight: 500;
      font-size: 1.2rem;
      tr {
        border-bottom: 3px solid hsl(0deg 0% 60%);
        th {
          padding: 0.5rem;
          span {
            display: block;
            font-size: 0.8rem;
            color: hsl(0deg 0% 60%);
          }
        }
      }
    }
  }
  &__total-table {
    width: 100%;
    margin-top: 1rem;
    color: #000;
    &-head {
      th {
        padding: 0.5rem;
        font-size: 1.2rem;
        color: #000;
        font-weight: 700;
        border-bottom: 10px solid #d3e1e2;
        &:last-child {
          width: 25%;
          border-bottom-color: #99cc98;
          text-align: center;
        }
      }
    }
    &-body {
      td {
        padding: 0.5rem;
        &:last-child {
          font-size: 1.5rem;
          width: 25%;
          text-align: center;
        }
      }
    }
    &-second {
      width: 100%;
      thead {
        color: hsl(0deg 0% 60%);
        font-weight: 700;
        font-size: 1rem;
        tr {
          border-bottom: 3px solid hsl(0deg 0% 60%);
          th {
            padding: 0.5rem;
            &:last-child {
              width: 75%;
              border-bottom-color: #99cc98;
              text-align: center;
            }
          }
        }
      }
      tbody {
        color: #000;
        font-weight: 500;
        font-size: 0.75rem;
        tr {
          border-bottom: 1px solid hsl(0deg 0% 60%);
        }
        td {
          padding: 0.5rem;
          span {
            display: block;
            font-size: 0.8rem;
            color: hsl(0deg 0% 60%);
          }
          &:last-child {
            text-align: center;
            font-size: 0.8rem;
          }
        }
      }
    }
  }
}
.fw-bold {
  font-weight: 700;
}
</style>

<style>
.vue-html2pdf .layout-container {
  background: none !important;
}
body {
  background-color: #fff !important;
}
</style>
